module.exports = __webpack_public_path__ + "img/20181214.c08e1778.png";